import { apiEndpoints as baseEnvActions } from "src/utils/api";

export const environment = {
    production: false,
    baseUrl: 'https://stage-api.hoppyapp.io/api',
    actions: baseEnvActions,
    firebaseApiKey: 'AIzaSyDHblKeVTlBlRLKPTS48GNmdJWSsSS-oH8'
};
